import { cn } from "@/lib/utils";
import { CATEGORY_CHIP } from "@/lib/charts";

export const CategoryChip = ({ category, overridden, testId }) => {
  if (!category) return <span className="text-xs text-ink-muted">—</span>;
  return (
    <span data-testid={testId} className={cn("inline-flex items-center gap-1 whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-medium", CATEGORY_CHIP[category])}>
      {category}{overridden && <span className="rounded-full bg-white/70 px-1 text-[10px]">overridden</span>}
    </span>
  );
};

export const ScoreBar = ({ value, compact }) => {
  if (value == null) return <span className="text-xs text-ink-muted">—</span>;
  const tone = value >= 75 ? "bg-success" : value >= 55 ? "bg-info" : "bg-ink-muted";
  return (
    <span className="flex items-center gap-2">
      <span className={cn("font-display font-semibold tabular-nums", compact ? "w-6 text-sm" : "w-8 text-base")}>{value}</span>
      <span className="h-1.5 w-20 rounded-full bg-[#EFEBE3]"><span className={cn("block h-full rounded-full", tone)} style={{ width: `${value}%` }} /></span>
    </span>
  );
};

export const Movement = ({ rank, prev }) => {
  if (!rank || !prev || prev === rank) return null;
  const up = prev > rank;
  return <span className={cn("text-xs", up ? "text-success" : "text-risk")} title={`Was #${prev}`}>{up ? "▲" : "▼"}{Math.abs(prev - rank)}</span>;
};
